import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useDeploymentAccountGroups} from '../hooks/useDeploymentAccountGroups';
import {DeploymentAccountGroup} from '../types';
import {FieldProps} from 'formik';

export const DeploymentAccountGroupsAutocomplete = ({
                                                        field: {
                                                            name,
                                                            value: fieldValue,
                                                        },
                                                        form: {setFieldValue},
                                                        ...rest
                                                    }: FieldProps) => {

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const {items: records} = useDeploymentAccountGroups();

    const data = records.map((record: DeploymentAccountGroup) => record.name || '');

    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: DeploymentAccountGroup) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            setValue(found.name as string);
        }
    }, [records.length, fieldValue]);

    const handleChange = (value: string) => {
        const found = records.find((item: DeploymentAccountGroup) => item.name === value);

        if (typeof found !== 'undefined') {
            setFieldValue(name, found.id);
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Deployment Account Group'
            {...rest}
        />
    );
};
